import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { CerrixButtonComponent } from "@app/shared/atoms/cerrix-button/cerrix-button.component";
import { CerrixDialogComponent } from "../cerrix-dialog/cerrix-dialog.component";

@Component({
    selector: "cerrix-confirm-dialog",
    imports: [CerrixButtonComponent, CerrixDialogComponent],
    templateUrl: "./cerrix-confirm-dialog.component.html",
    styleUrl: "./cerrix-confirm-dialog.component.scss",
    encapsulation: ViewEncapsulation.None,
})
export class CerrixConfirmDialogComponent {
    @Input() public name: string;
    @Input() public dataUiid: string;
    @Input() public icon: string;
    @Input() public title: string;
    @Input() public description: string;
    @Input() public cancelText: string;
    @Input() public confirmText: string;
    @Input() public waitingOnResult: boolean = false;
    @Input() public showResultText: boolean = false;
    @Output() public cancel = new EventEmitter<void>();
    @Output() public confirm = new EventEmitter<void>();
}
